// Smart Magenta -- calculadora de frete por CEP na pagina do produto.
// ASCII puro (ver CLAUDE.md). Cotacao vem de /cart/shipping_rates.json,
// que e o mesmo calculo do checkout.
(function () {
  var raiz = document.querySelector('.sm-cep');
  if (!raiz) return;

  // A caixa nasce no bloco de specs porque o template do produto e nativo
  // e nao aceita HTML nosso entre os blocos dele. Aqui ela e movida para
  // logo abaixo de "Adicionar ao carrinho" / "Compre ja", que e onde a
  // pessoa procura frete depois de decidir. Se o tema mudar de estrutura
  // e o alvo sumir, a caixa simplesmente fica onde estava.
  var compra = document.querySelector('[class*="buy-buttons-block"]');
  if (compra && compra.parentElement) {
    // Vai dentro do bloco do proprio botao, nao ao lado dele: a coluna de
    // detalhes e uma grade, e filho novo direto nela cai na primeira
    // faixa -- a caixa aparecia no topo, acima do titulo.
    compra.parentElement.insertBefore(raiz, compra.nextSibling);
    raiz.classList.add('sm-cep-na-compra');
  }
  var campo = document.getElementById('sm-cep-in');
  var botao = document.getElementById('sm-cep-bt');
  var saida = document.getElementById('sm-cep-r');

  function moeda(c) {
    return 'R$ ' + (c / 100).toFixed(2).replace('.', ',');
  }
  function mostra(html, classe) {
    saida.className = 'sm-cep-r' + (classe ? ' ' + classe : '');
    saida.innerHTML = html;
  }

  campo.addEventListener('input', function () {
    var d = campo.value.replace(/\D/g, '').slice(0, 8);
    campo.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
  });
  campo.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); botao.click(); }
  });

  botao.addEventListener('click', function () {
    var cep = campo.value.replace(/\D/g, '');
    if (cep.length !== 8) { mostra('Digite os 8 n\u00fameros do CEP.', 'sm-cep-erro'); return; }
    var vid = raiz.getAttribute('data-variante');
    botao.disabled = true;
    mostra('Consultando as transportadoras...', 'sm-cep-carrega');

    // O carrinho da pessoa e preservado: guardamos o estado, cotamos com o
    // produto aberto e devolvemos o carrinho ao que era.
    var antes = null;
    var lugar = null;
    // O /cart/shipping_rates.json recusa o CEP sozinho ("Selecione um
    // estado"), entao o ViaCEP traduz CEP em cidade e UF antes da cotacao.
    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (v) {
        if (!v || v.erro) throw new Error('cep inexistente');
        lugar = v;
        // Avisa quem mais precisa da UF nesta pagina -- hoje o bloco de
        // preco de revenda, que muda de valor dentro de SC (ICMS interno).
        document.dispatchEvent(new CustomEvent('sm:uf', { detail: { uf: v.uf } }));
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        antes = c;
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        });
      })
      .then(function () {
        return fetch('/cart/shipping_rates.json' +
                     '?shipping_address%5Bzip%5D=' + encodeURIComponent(cep) +
                     '&shipping_address%5Bcountry%5D=Brazil' +
                     '&shipping_address%5Bprovince%5D=' + encodeURIComponent(lugar.uf) +
                     '&shipping_address%5Bcity%5D=' + encodeURIComponent(lugar.localidade));
      })
      .then(function (r) {
        if (!r.ok) throw new Error('cotacao indisponivel');
        return r.json();
      })
      .then(function (d) {
        var taxas = (d && d.shipping_rates) || [];
        if (!taxas.length) {
          mostra('N\u00e3o achamos entrega para esse CEP. ' +
                 '<a href="https://wa.me/554735130885" target="_blank" rel="noopener">' +
                 'Fale com a gente</a> que a gente cota na m\u00e3o.', 'sm-cep-erro');
          return;
        }
        var barata = taxas[0];
        for (var i = 1; i < taxas.length; i++) {
          if (Number(taxas[i].price) < Number(barata.price)) barata = taxas[i];
        }
        var centavos = Math.round(Number(barata.price) * 100);
        var prazo = '';
        if (barata.delivery_days && barata.delivery_days.length) {
          var dias = barata.delivery_days[barata.delivery_days.length - 1];
          prazo = ' - chega em at\u00e9 ' + dias + (dias === 1 ? ' dia \u00fatil' : ' dias \u00fateis');
        }
        var onde = lugar ? ' para ' + lugar.localidade + '/' + lugar.uf : ' para o seu CEP';
        if (centavos === 0) {
          mostra('<b class="sm-cep-ok">Frete gr\u00e1tis</b>' + onde + prazo + '.', 'sm-cep-bom');
        } else {
          mostra('<b>' + moeda(centavos) + '</b>' + onde + ' por ' + barata.name + prazo +
                 '.<br><span class="sm-cep-nota">Parte desse valor j\u00e1 est\u00e1 no pre\u00e7o do ' +
                 'produto e volta como desconto no carrinho.</span>', 'sm-cep-bom');
        }
      })
      .catch(function () {
        mostra('N\u00e3o consegui calcular agora. Tente de novo em instantes ou veja o ' +
               'valor no carrinho.', 'sm-cep-erro');
      })
      .then(function () {
        botao.disabled = false;
        // devolve o carrinho ao estado anterior
        if (!antes) return;
        var itens = {};
        for (var i = 0; i < antes.items.length; i++) {
          itens[String(antes.items[i].variant_id)] = antes.items[i].quantity;
        }
        if (!itens[String(vid)]) itens[String(vid)] = 0;
        fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: itens })
        });
      });
  });
})();
